import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { PATIENT_JOURNEY } from './salesData';
export function JourneySection() {
  return <section id="recorrido" className="bg-ivory py-12 sm:py-16" data-id="element-229" data-mp="3t3qvxwcpzw0v">
      <div className="mx-auto max-w-5xl px-5" data-id="element-230" data-mp="1vv4mmsfhyhh">
        <div className="text-center" data-id="element-231" data-mp="1wo8ng0069vx">
          <SectionTag data-id="element-232" data-mp="plpfwzx3nezm">El recorrido</SectionTag>
          <h2 className="mt-4 font-display text-[1.45rem] font-bold uppercase leading-tight text-charcoal sm:text-[2.1rem]" data-id="element-233" data-mp="pn0ln5a3uwtd">
            Todo paciente recorre
            <span className="mt-1 block text-gold-deep" data-id="element-234" data-mp="glat1w4hlru0">siempre el mismo camino</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl font-sans text-[0.9rem] leading-relaxed text-charcoal/70 sm:text-base" data-id="element-235" data-mp="kmco00rdfhq6">
            Desde la primera consulta hasta el cobro hay ocho pasos. En cada uno se puede ganar o
            perder dinero. La rentabilidad de tu consultorio se define en el porcentaje de personas
            que llegan de un paso al siguiente.
          </p>
        </div>

        <ol className="mt-8 flex flex-wrap items-stretch justify-center gap-2" data-id="element-236" data-mp="2ugqo5oh6scgz">
          {PATIENT_JOURNEY.map((step, i) => <React.Fragment key={step} data-id="element-237" data-mp="38hb7qmuxecbj" data-mpi={i}>
              <motion.li initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-40px'
          }} transition={{
            duration: 0.3,
            delay: i * 0.05
          }} className="flex min-w-[8.5rem] flex-1 flex-col justify-center rounded-xl border border-stone bg-sand px-3.5 py-3" data-id="element-238" data-mp="38e5k7c1y3ihx">
                <span className="font-sans text-[0.58rem] font-bold uppercase tracking-editorial text-gold-deep tabular-nums" data-id="element-239" data-mp="3s3g1guhcabi5">
                  Paso 0{i + 1}
                </span>
                <span className="mt-1 font-display text-[0.95rem] font-bold uppercase leading-tight text-charcoal" data-id="element-240" data-mp="502s89no7ojz">
                  {step}
                </span>
              </motion.li>
              {i < PATIENT_JOURNEY.length - 1 && <li className="hidden items-center sm:flex" aria-hidden data-id="element-241" data-mp="2yrizha411en0">
                  <ChevronRightIcon className="h-4 w-4 text-gold" data-id="element-242" data-mp="2ypewqvhv6lob" />
                </li>}
            </React.Fragment>)}
        </ol>

        <div className="mt-6 rounded-2xl border border-gold/40 bg-gold-soft/40 px-5 py-5 text-center" data-id="element-243" data-mp="37k2zadw21p9f">
          <p className="mx-auto max-w-2xl font-sans text-[0.9rem] font-medium leading-relaxed text-charcoal sm:text-base" data-id="element-244" data-mp="3chusrcccljfq">
            No hace falta cambiar todo el recorrido. Con mejorar apenas unos puntos porcentuales en
            tres o cuatro pasos, la facturación del mismo consultorio cambia de forma notable.
          </p>
        </div>
      </div>
    </section>;
}